import React, { useState } from "react";
import axios from "axios";
import { Fade } from "react-reveal";
import { InputText } from 'primereact/inputtext';
import { Password } from 'primereact/password';


import { LOGIN_STATES } from "../../data/Login/LoginStates";
import LoginHelper from "../../data/Login/LoginHelper";

const LoginForm = ({
    loginEmail = "",
    loginPassword = "",
    loginError = "",
    loginErrorMessage = "",
    setLoginState,
    updateReducerState,
}) => {
    // Local States
    const [email, setEmail] = useState(loginEmail);
    const [password, setPassword] = useState(loginPassword);
    const [error, setError] = useState(loginError);
    const [errorMessage, setErrorMessage] = useState(loginErrorMessage);

    const handleLoginSubmit = (event) => {
        event.preventDefault();

        axios.post('/api/login', {
            withCredentials: true,
            data: {
                email: email,
                password: password,
            },
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
        }).then((res) => {
            if (res.data.status) {
                window.location.reload(false);
            } else {
                setError(true);
                setErrorMessage(res.data.message);
            }
        })
            .catch((err) => {
                setError(true);
                setErrorMessage(false);
            });
    };

    return (
        <>
            <div className="login-box">
                <h1 className="header">Login to Account</h1>

                <form onSubmit={handleLoginSubmit}>
                    <label>
                        Email: {LoginHelper.verifyEmail() ? <i class="fa-solid fa-check green-check"></i> : <i class="fa-thin fa-asterisk red-asterisk" />}
                        <InputText value={email} onChange={(event) => {
                            setEmail(event.target.value);
                            updateReducerState('loginEmail', event.target.value);
                        }} />
                    </label>

                    <label>
                        Password: {password.length === 0 ? <i class="fa-thin fa-asterisk red-asterisk" /> : <i class="fa-solid fa-check green-check"></i>}
                        <Password type="password" name="password" value={password} onChange={(event) => {
                            setPassword(event.target.value);
                            updateReducerState('loginPassword', event.target.value);
                        }} toggleMask={true} />
                    </label>

                    <Fade bottom when={error}>
                        {error && <h3 className="error-text">{errorMessage}</h3>}
                    </Fade>

                    <div className="login-buttons">
                        <div>
                            {LoginHelper.verifyEmail(email) ?
                                <>
                                    <button className="login-button approved-button" type="submit">Submit <i class="fa-solid fa-check" /></button>
                                </>
                                :
                                <>
                                    <button className="login-button denied-button" type="submit" disabled>Submit <i class="fa-thin fa-x" /></button>
                                </>
                            }
                        </div>

                        <div>
                            <button className="login-button pending-button" type="button"
                                onClick={() => setLoginState(LOGIN_STATES.FORGOT)}>Forgot Password? <i class="fa-solid fa-thought-bubble"></i></button>
                        </div>
                    </div>
                </form>

                <p>Don't Have an Account?</p>
            <button className="login-toggle-button all-button"
                type="button"
                onClick={() => setLoginState(LOGIN_STATES.SIGNUP)}>
                Signup <i class="fa-solid fa-right-to-bracket"></i>
            </button>
            </div>


        </>
    )
};

export default LoginForm;